import 'mdn-polyfills/NodeList.prototype.forEach';
import Slider from './Slider';

document.addEventListener('DOMContentLoaded', () => {
  const sliderElements = document.querySelectorAll('.js-slider');
  if (!sliderElements.length) {
    return;
  }
  sliderElements.forEach(($sliderElement) => {
    const slider = new Slider($sliderElement);
    slider.mount();
  });
});
